import { gsap } from 'gsap'

const setTextAnim = () => {

  const inner = document.querySelector('.js-hero-news__desc__inner');
  if (!inner) return;

  const outer = inner.parentElement;

  const innerWidth = inner.scrollWidth
  const outerWidth = outer.clientWidth

  if (innerWidth > outerWidth) {
    const speed = 20;

    gsap
    .timeline()
      .to(inner,
        {
          x: -innerWidth,
          duration: innerWidth / speed,
          ease: "none",
        }
      )

      .fromTo(inner,
        {
          x: outerWidth
        },
        {
          // x: () => -(inner.scrollWidth - outer.clientWidth),
          x: -innerWidth,
          duration: (innerWidth + outerWidth) / speed,
          ease: "none",
          repeat: -1,
          // yoyo: false,
          repeatDelay: 0,
          immediateRender: false,
        }
      );
  }

}

export default setTextAnim;